
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 307.93 307.93"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"none","d":"M0 0h307.93v307.93H0z"}})])]),_c('g',{attrs:{"data-name":"Calque 2"}},[_c('g',{attrs:{"data-name":"Calque 3"}},[_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"d":"M154 307.93A154 154 0 100 154a154 154 0 00154 154","fill":"#00577b"}})]),_c('path',{attrs:{"d":"M58.44 83.27s17.17 60 128.26 114.85M70 108.71s-17.67 27.55 5.65 57.07c4.64-11.59 4.26-13.34 4.26-13.34l6.3 26.91 30.51 21.32 6.09-19.83 5.38 25.07 35.45 15.21-.1-15.12 10.55 20.13s40.81 9.12 56.84-6.9 19.85-21.7 19.85-21.7-19.81 6-42.22-8.91a35.69 35.69 0 009.6-3.57l-40.62-35.37-21.61 1.57 12.84-9.7-19.58-21.67s-16.51-3.44-31.18-.28c5.49-3.43 22.14-8 22.14-8S130.13 89.13 70 108.71z","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"10","fill":"none"}})])])])
          )
        }
      }
    